import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { IonContent, IonFooter, IonHeader } from '@ionic/react';

import { loadName } from 'helpers/loads';
import { userSettingsSelector } from 'selectors/userSelector';
import { ProjectContext } from 'components/layouts/Project';
import SlideHeader from 'components/helpers/SlideHeader';
import PileTypeSelction from './pile-selection/PileTypeSelection';
import PileSelection from './pile-selection/PileSelection';
import RequiredCapacity from './RequiredCapacity';

export default function Pile() {
  const {data} = useContext(ProjectContext);
  const defaultPileType = "helical" || useSelector(userSettingsSelector.at('defaultPileType'));

  return (
    <Swiper loop className="full-screen">
      {data?.loads.map((load, index) => (
        <SwiperSlide key={load.id}>
          <div className="ion-page">
            {data?.loads.length > 1 && (
              <IonHeader>
                <SlideHeader className={`pile-header load-${index}`}>
                  {loadName(load, index)}
                </SlideHeader>
              </IonHeader>
            )}
            <IonContent>
              {_.isString(load.pileType ?? defaultPileType) ? (
                <PileSelection load={load}/>
              ) : (
                <PileTypeSelction load={load}/>
              )}
            </IonContent>
            <IonFooter>
              <RequiredCapacity load={load} loadIndex={index}/>
            </IonFooter>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
